import { Config } from '@/models/Config.js';

const initialState = new Config();

export const state = initialState
